module.exports = __webpack_public_path__ + "static/media/SecurityGateEntryTemplate1.ae3645fd.png";